/**
 * Notification Item component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
    notificationType,
} from 'Types/notification';

export default class NotificationItem extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        item: notificationType.isRequired,
        removeNotify: PropTypes.func.isRequired,
    };

    /**
     * @type {Object}
     */
    state = {
        show: false,
    };

    componentDidMount () {
        this.timeout = setTimeout(() => {
            this.setState({
                show: true,
            });
            this.timeout = setTimeout(() => {
                this.removeNotify();
            }, 5000);
        });
    }

    componentWillUnmount () {
        clearTimeout(this.timeout);
    }

    timeout = null;

    removeNotify = () => {
        this.setState({
            show: false,
        }, () => {
            this.timeout = setTimeout(() => {
                this.props.removeNotify(this.props.item.id);
            }, 200);
        });
    };

    render () {
        const { item: { message, type } } = this.props;
        const { show } = this.state;

        return (
            <div className={ cx('alert', `alert-${ type === 'error' ? 'danger' : type }`, { show }) }>
                { message }
                <button
                    className="close"
                    onClick={ this.removeNotify }
                    type="button"
                >
                    <i className="fas fa-xs fa-times"/>
                </button>
            </div>
        );
    }
}
